import { format as dateFormat, formatWithOptions, parseISO } from 'date-fns/fp';
import de from 'date-fns/locale/de';
import enGB from 'date-fns/locale/en-GB';
import fr from 'date-fns/locale/fr';
import it from 'date-fns/locale/it';
import nl from 'date-fns/locale/nl';
import sv from 'date-fns/locale/sv';
import { compose } from 'ramda';

import { i18n } from '@i18n';

const customSv: typeof sv = {
    ...sv,
    localize: {
        ...sv.localize,
        month: (n: number, options?: { width?: string; context?: string }) => {
            const name = sv.localize?.month(n, options);
            return name?.replace(/\.$/, '');
        }
    } as typeof sv.localize
};

export const locales = {
    itIT: it,
    frFR: fr,
    deCH: de,
    nlNL: nl,
    svSE: customSv,
    enGB
};

export const propsChanged =
    (props: Record<string, unknown>, prevProps: Record<string, unknown>) =>
    (...keys: string[]) =>
        keys.some((k) => props[k] !== prevProps[k]);

export const transformLanguageCode = (lang = 'en-gb') => {
    const [languageCode, countryCode] = lang.split('-');
    return `${languageCode}${countryCode.toUpperCase()}`;
};

export const defaultFormat = 'dd MMM yyyy';
export const defaultDateFormatWithFullMonth = 'dd MMMM yyyy';
export const defaultDateTimeFormat = 'dd MMM yyyy, HH:mm';
export const defaultDateTimeFormatWithFullMonth = 'dd MMMM yyyy, HH:mm';
export const defaultTimeFormat = 'HH:mm';
const defaultLocale = 'en-GB';

export const formatDate = (
    date: string | Date | undefined | null,
    format?: string,
    locale?: string
) => {
    if (!date) return '';
    const localeKey = transformLanguageCode(
        locale || i18n?.language || defaultLocale
    ) as keyof typeof locales;
    const userLocale = locales[localeKey];
    return formatWithOptions(
        { locale: userLocale },
        format || defaultFormat,
        date instanceof Date ? date : parseISO(date)
    );
};

export const parseTime = (formatString: string) => compose(dateFormat(formatString), parseISO);

export const stripZeroWidthCharacters = (text: string | undefined) => {
    return text?.replace(/[\u200B-\u200D\uFEFF]/g, '');
};
